import React from 'react';
import { Lock, ShieldCheck } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
import { CTAButton } from './ui/CTAButton';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <AnimatedSection className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-navy-900 pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-39">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-400/5 rounded-full blur-[120px] pointer-events-none" data-id="element-40" />

      <div className="relative max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-41">
        <div className="text-center lg:text-left space-y-8" data-id="element-42">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-43">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-balance mb-6" data-id="element-44">
              El Excedente Fantasma:{' '}
              <span className="text-gold-400" data-id="element-45">
                El Sistema para dejar de vivir "al día"
              </span>{' '}
              sin sacrificar tu estilo de vida
            </h1>
            <p className="text-lg sm:text-xl text-slate-300 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-46">
              Recupera los $75 - $150 que hoy desaparecen de tu cuenta y
              conviértelos en estabilidad financiera real (aunque no sepas nada
              de inversiones).
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col items-center lg:items-start gap-4" data-id="element-47">
            <CTAButton href="#precio" className="w-full sm:w-auto text-center" data-id="element-48">
              QUIERO MI GUÍA DEL EXCEDENTE FANTASMA
            </CTAButton>

            <div className="flex items-center gap-2 text-sm text-slate-400" data-id="element-49">
              <Lock className="w-4 h-4 text-gold-400" data-id="element-50" />
              <span data-id="element-51">
                Acceso inmediato tras la compra. Pago seguro y cifrado.
              </span>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-52">
          <div className="absolute inset-0 bg-gradient-to-tr from-gold-400/20 to-transparent rounded-3xl blur-2xl transform -rotate-6" data-id="element-53" />
          <img src="https://cdn.magicpatterns.com/uploads/jPpPCC1c1pNVeiMH8Y2YPA/Imagen_inicial_del_Excedente_Fantasma.png" alt="Mockup del producto El Excedente Fantasma en tablet y móvil" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-2xl border border-navy-700/50" data-id="element-54" />
        </motion.div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/30 to-transparent" data-id="element-55" />
    </AnimatedSection>;
}